__turbopack_context__.v({
  "contacts": "TeamContactInfoView-module-scss-module__P4bQCG__contacts",
});
